import React from "react";
import PropTypes from "prop-types";
import backButton from "@/assets/images/button-back.png";
import camTurn from "@/assets/images/cam-turn.png";

const Header = props => {
	const camTurnClicked = () => {
		document.dispatchEvent(new Event("camera-turn"));
	};

	const goBack = () => {
		const header = document.querySelector(".header");
		if (header.hasAttribute("camera-go-back")) {
			return document.dispatchEvent(new Event("camera-go-back"));
		}

		if (!props.content.hasBack) {
			return;
		}
		props.decreaseStep();
	};

	return (
		
		<div
			/* eslint-disable */
			has-back={props.content.hasBack.toString()}
			/* eslint-enable */
			className={`header flex px-4 size-${props.content.headerSize} ${props.content.classes || "bg-defaultHeaderBg"}`}>
			<div className="w-1/4 flex">
				<button onClick={goBack} className={`${props.content.hasBack ? "" : "hidden"} btn-back mr-auto p-2`}>
					<img src={backButton} />
				</button>
			</div>
			<div className="w-1/2 flex">{props.content.logo && <img src={props.content.logo[props.content.headerSize]} className="logo m-auto" />}</div>
			<div className="w-1/4 flex">
				{props.content.hasNext && (
					<button id="next-button-holder" onClick={props.increaseStep} className="btn-back btn-next ml-auto p-2">
						<img src={backButton} />
					</button>
				)}

				<button id="camera-turn-holder" onClick={camTurnClicked} className="hidden btn-back btn-next ml-auto p-2">
					{/* eslint-disable-next-line */}
					<img pre-src={camTurn} />
				</button>
			</div>
		</div>
	);
};

Header.propTypes = {
	content: PropTypes.object,
	decreaseStep: PropTypes.func,
	increaseStep: PropTypes.func
};

export default Header;
